export default __webpack_public_path__ + "static/media/star.9e227884.svg";